/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Col_ScoreInputs */



/**
* | output |
* | --- |
* | "Score" |
*
* @param {Tournament_Col_ScoreInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_col_score = /** @type {((inputs?: Tournament_Col_ScoreInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Col_ScoreInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Score")
	if (locale === "es") return /** @type {LocalizedString} */ ("Puntuación")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Pontuação")
	if (locale === "it") return /** @type {LocalizedString} */ ("Punteggio")
	return /** @type {LocalizedString} */ ("Score")
});